import React from "react";
import { FormattedMessage } from "react-intl";
import css from "./StatusBadge.css";
var StatusBadge = function (_a) {
    var status = _a.status;
    var isActive = status === "ACTIVE";
    return (React.createElement("span", { className: css.statusBadge },
        React.createElement("span", { className: "".concat(css.statusDot, " ").concat(isActive ? css.active : css.inactive) }),
        React.createElement(FormattedMessage, { id: "ui-czna-users.status.".concat(status.toLowerCase()) })));
};
export default StatusBadge;
